import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const BulkActions = ({ selectedCount, onBulkAction }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const actions = [
    {
      id: 'activate',
      label: 'Активировать',
      icon: 'UserCheck',
      color: 'text-success',
      description: 'Активировать выбранных пользователей'
    },
    {
      id: 'deactivate',
      label: 'Деактивировать',
      icon: 'UserX',
      color: 'text-warning',
      description: 'Деактивировать выбранных пользователей'
    },
    {
      id: 'export',
      label: 'Экспортировать',
      icon: 'Download',
      color: 'text-accent',
      description: 'Экспортировать данные в CSV'
    },
    {
      id: 'delete',
      label: 'Удалить',
      icon: 'Trash2',
      color: 'text-error',
      description: 'Удалить выбранных пользователей',
      dangerous: true
    }
  ];

  const handleAction = (actionId) => {
    if (actionId === 'delete') {
      if (window.confirm(`Вы уверены, что хотите удалить ${selectedCount} пользователей? Это действие нельзя отменить.`)) {
        onBulkAction(actionId);
      }
    } else if (actionId === 'deactivate') {
      if (window.confirm(`Деактивировать ${selectedCount} пользователей?`)) {
        onBulkAction(actionId);
      }
    } else {
      onBulkAction(actionId);
    }
    setIsDropdownOpen(false);
  };

  return (
    <div className="flex items-center gap-4 p-3 bg-primary-50 border border-primary-200 rounded-md">
      <div className="flex items-center gap-2">
        <Icon name="CheckSquare" size={16} className="text-primary-600" />
        <span className="text-sm font-medium text-primary-700">
          Выбрано {selectedCount} пользователей
        </span>
      </div>

      <div className="flex items-center gap-2">
        {/* Quick Actions */}
        <button
          onClick={() => handleAction('activate')}
          className="
            flex items-center gap-2 px-3 py-1.5 bg-success text-white rounded-md text-sm
            hover:bg-success-600 transition-colors duration-150 hover-lift
          "
        >
          <Icon name="UserCheck" size={14} />
          Активировать
        </button>

        <button
          onClick={() => handleAction('export')}
          className="
            flex items-center gap-2 px-3 py-1.5 bg-accent text-white rounded-md text-sm
            hover:bg-accent-700 transition-colors duration-150 hover-lift
          "
        >
          <Icon name="Download" size={14} />
          Экспорт
        </button>

        {/* More Actions Dropdown */}
        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="
              flex items-center gap-2 px-3 py-1.5 border border-primary-300 text-primary-700 rounded-md text-sm
              hover:bg-primary-100 transition-colors duration-150 hover-lift
            "
          >
            Еще
            <Icon name="ChevronDown" size={14} />
          </button>

          {isDropdownOpen && (
            <div className="
              absolute top-full right-0 mt-1 w-56 bg-surface border border-secondary-200 rounded-md shadow-lg z-10
              glass-morphism
            ">
              <div className="p-2">
                {actions.map((action) => (
                  <button
                    key={action.id}
                    onClick={() => handleAction(action.id)}
                    className={`
                      w-full flex items-start gap-3 px-3 py-2 rounded-md text-left
                      hover:bg-secondary-50 transition-colors duration-150
                      ${action.dangerous ? 'hover:bg-error-50 hover:text-error' : ''}
                    `}
                  >
                    <Icon name={action.icon} size={16} className={action.color} />
                    <div>
                      <p className="text-sm font-medium text-text-primary">
                        {action.label}
                      </p>
                      <p className="text-xs text-text-secondary">
                        {action.description}
                      </p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Close Selection */}
      <button
        onClick={() => onBulkAction('clear')}
        className="
          ml-auto p-1 rounded-md hover:bg-primary-100 transition-colors duration-150
        "
        title="Снять выделение"
      >
        <Icon name="X" size={16} className="text-primary-600" />
      </button>
    </div>
  );
};

export default BulkActions;